import { render, staticRenderFns } from "./ShareCustomPrivileges.vue?vue&type=template&id=4207526a&scoped=true"
import script from "./ShareCustomPrivileges.vue?vue&type=script&lang=js"
export * from "./ShareCustomPrivileges.vue?vue&type=script&lang=js"
import style0 from "./ShareInstanceModal.scss?vue&type=style&index=0&id=4207526a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4207526a",
  null
  
)

export default component.exports